import React from 'react';
import NumberFormat from "react-number-format";

function limit(val, max, type) {
    let year = new Date();
    let currentYear = year.getFullYear();
    if (val.length === 1 && val[0] > max[0]) {
        val = "0" + val;
    }

    if (val.length === 2) {
        if (Number(val) === 0) {
            val = "01";

            //this can happen when user paste number
        } else if (val > max) {
            val = max;
        }
    }

    if (val.length === 4) {
        if (Number(val) === 0) {
            val = "0001";
            // this can happen when user paste number
        } else if (val > max) {
            val = max;
        } else if (val < 1900) {
            val = max;
        }
    }

    return val;
}
function Dob(props) {
    const DOBExpiry = (val) => {
        var d = new Date();
        var getyear = d.getFullYear();
        let days = limit(val.substring(0, 2), "31");
        let month = limit(val.substring(2, 4), "12");
        let year = limit(val.substring(4, 8), getyear);

        return (
            days +
            (month.length ? "/" + month : " ") +
            (year.length ? "/" + year : "/" + year)
        );
    };
    return (
        <NumberFormat
            className="txtbox"

            format={DOBExpiry}
            placeholder="DD/MM/YYYY"
            onBlur={props.onBlur}
            id={props.name}
            name={props.name}
            onValueChange={props.onChange}
            value={props.value || ""}
        />
    )
}

export default Dob

